import Vue from 'vue'
import {
  Button,
  Carousel,
  CarouselItem,
  Message,
  Pagination,
  Table,
  TableColumn
} from 'element-ui'

Vue.use(Button)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Pagination)
Vue.use(Table)

Vue.prototype.$message = Message
